<template lang="pug">
  b-card.no-shadow(no-body)
    .d-flex.align-items-center.px-3.pt-3
      v-icon.mr-2(:name="description", scale="1.2")
      h4.mb-0 {{ title }}
      b-spinner(small, variant="primary", v-if="loading")
    div
      b-list-group.list-group-flush.mb-0
        b-list-group-item
          div.mb-0.text-danger(v-if="error")
            p.mb-0 Error obteniendo información de la cuenta
            b-link.text-sm(@click="$emit('refresh')")
              rotate-ccw-icon.icon-sm.mr-1
              span Reintentar
          div(v-else)
            p.mb-2.text-secondary Cuentas conectadas:
            b-form-row.align-items-start.p-2.bg-light.rounded(v-for="(account, index) in accounts", :key="index", :class="index != accounts.length - 1 ? 'mb-3' : ''")
              b-col.align-items-center(v-b-toggle="account.phone_status?parseNumber(account.phone_status):''")
                h4.mb-1 {{ name == 'twitter' || name == 'twitterDM' ? '@' : '' }}{{ account.phone_status? account.phone_status.verified_name: account.name || `Cuenta conectada - ${index + 1}` }}
                div.mb-2(v-if="account.phone_status" :id="parseNumber(account.phone_status)")
                  p.mb-1 Reputación:
                    span(:style="{color:getStatusColor(account.phone_status)}") {{ parsePhoneStatus(account.phone_status) }}
                  p.mb-1 Linea: {{parseNumber(account.phone_status)}}
                div.align-items-center.mb-2.ml-auto(v-if="account.phone_status")
                  h5.mb-1 Mensajes
                  p.mb-0 Métricas de la ultima semana {{waMetricsDates}}
                  b-badge.badge-pill.badge-primary Enviados: {{account.phone_status.stats.sent }}
                  b-badge.ml-2.badge-pill.badge-success Entregados: {{account.phone_status.stats.delivered }}
                b-link.text-sm(@click="$emit('authenticate')", v-if="canAuthenticate(name) && reconnectable.includes(name)") Cambiar cuenta
              b-col(cols="auto")
                b-button.m-1(variant="soft-primary", size="sm", v-if="canConfigPlatform(account)", @click="$emit('toggle_config', account)")
                  settings-icon.icon-sm
                b-dropdown.m-1(no-caret, dropleft,  variant="soft-primary", size="sm", v-if="menu.includes(name)")
                  template(slot="button-content")
                    more-vertical-icon.icon-sm
                  b-dropdown-group(v-if="name == 'bmessaging'")
                    b-dropdown-item-button(@click="openWindow(account.external_id)") Abrir link público
                  b-dropdown-group(v-if="extendedMenu.includes(name)")
                    b-dropdown-item-button(@click="$emit('reconnect', account)", v-if="reconnectable.includes(name)") Reconectar cuenta
                    b-dropdown-item-button(@click="$emit('desconnect', account)", v-if="disconnectable.includes(name)") Desconectar cuenta
            //- b-button.mt-3(variant="primary", @click="$emit('connect')", :block="$breakpoint.smDown")
            //-   plus-icon.icon-sm.mr-2.mb-1
            //-   span Conectar cuenta de {{ title }}
        b-list-group-item.pb-3
          b-row.align-items-center
            b-col.mb-md-0.mb-2
              span.text-help.text-sm Si apagas {{ title }}, el Chatbot dejará de contestar a todas las conversaciones de esta plataforma.
                b Puedes apagar el bot sólo en algunas conversaciones en la sección de Chats > Conversación > Apagar Bot.
            b-col(md="auto")
              b-button.d-block.ml-auto(:block="$breakpoint.smDown", :variant="respondingAuto ? 'danger' : 'success'", @click="$emit('responding_mode', responding_mode == 'auto' ? 'manual' : 'auto')")
                power-icon.mr-2.icon-sm.mb-1
                span {{ responding_mode == 'auto' ? 'Apagar' : 'Prender' }} {{ title }}
        b-list-group-item.pt-3.pb-3(v-if="$can('read', 'disable-platform')")
          b-row.align-items-center
            b-col.mb-md-0.mb-2
              p.mb-0
                alert-triangle-icon.icon-sm.mr-2.mb-1
                span Zona peligrosa
              p.text-help.text-sm.mb-0 Si deshabilitas la plataforma algunas funciones del dashboard quedarán deshabilitadas. Si solo deseas suspender las respuestas del Chatbot, prueba el botón de arriba que dice "Apagar {{ title }}".
            b-col(md="auto")
              b-button(size="sm", :variant="enabled ? 'outline-danger' : 'soft-success'", @click="$emit('enabled', !enabled)") {{ enabled ? 'Deshabilitar plataforma' : 'Habilitar plataforma' }}
</template>

<script>
import {createNamespacedHelpers, mapActions} from 'vuex'
import authenticateHelper from '@/helpers/authenticate-helper'
const partnerController = createNamespacedHelpers('partner')
const accountController = createNamespacedHelpers('account')

export default {
  mixins: [authenticateHelper],
  data () {
    return {
      menu: ['bmessaging', 'facebook', 'messenger', 'instagram', 'whatsapp_gupshup'],
      extendedMenu: ['facebook', 'messenger', 'instagram', 'whatsapp_gupshup'],
      reconnectable: ['facebook', 'messenger', 'instagram'],
      disconnectable: ['facebook', 'messenger', 'instagram', 'whatsapp_gupshup']
    }
  },
  props: {
    platform_id: {
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    responding_mode: {
      type: String,
      default: 'auto'
    },
    enabled: {
      type: Boolean,
      default: false
    },
    description: {
      type: String,
      default: 'comment-alt'
    },
    accounts: {
      type: Array,
      default: function () {
        return []
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ''
    },
    // phone_status:{
    //   type: Object,
    //   default: {}
    // }
  },
  computed: {
    ...partnerController.mapState({
      partner: state => state.partner
    }),
    ...accountController.mapState({
      account: state => state.account
    }),
    respondingAuto () {
      return this.responding_mode == 'auto' || this.responding_mode == '1'
    },
    waMetricsDates(){
      const today = new Date().toLocaleDateString()
      const oneWeekAgo = new Date(new Date().setDate(new Date().getDate() - 7)).toLocaleDateString()
      return `${oneWeekAgo} - ${today}`
    },
  },
  methods: {
    openWindow (bmid) {
      let route = `/probar-chatbot?bmid=${bmid}&a=${this.$route.params.account_id}`

      if(this.partner && this.partner.business_logo) route += `&p=${this.partner.business_logo}`
      let isEcommerce = (new RegExp('^konverza-ecommerce', 'i')).test(this.account.type)
      if(isEcommerce) route += `&e=true`

      let w = window.open(route, '_blank')
      w.focus()
    },
    parsePhoneStatus(waAccount){
      const status = waAccount.quality_rating || ''
      return  this.quality_rating(status)
      },
    parseNumber(waAccount){
      return waAccount.display_phone_number || ''
    },
    getStatusColor(waAccount){
      return this.quality_colors(waAccount.quality_rating)
    },
    quality_rating(status){
      switch(status){
        case 'GREEN':
          return 'Buena'
        case 'YELLOW':
          return 'Regular'
        case 'RED':
          return 'Mala'
        default:
          return 'No disponible'
      }
    },
    quality_colors(status){
        switch(status){
        case 'GREEN':
          return '#73b43c'
        case 'YELLOW':
          return '#ffed3e'
        case 'RED':
          return '#fc4b59'
        default:
          return '#a0b1cc'
      }
    },
    canConfigPlatform (account) {
      switch (this.name) {
        case 'bmessaging':
        case 'alexa':
          return true
        case 'messenger':
          return this.$can('read', 'messenger-settings')
        case 'voicebot':
        case 'whatsapp_official':
          return !!account.phone_number
        default:
          return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
